"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { fetchMoreReplies } from "@/app/[domain]/(sites)/_actions/comments/fetch-more-replies";
import { commentConfig } from "@/components/Comment/config/comment.config";
import { useComment } from "@/components/Comment/context/comment.context";
import { useCommentsActions } from "@/components/Comment/hooks/use-comment-actions.hook";
import { Translation } from "@/components/Translation/Translation.component";
import { captureClientException } from "@/services/logging/capture-client-exception";
import { hasFailed, hasSucceeded } from "@/services/utilities/fetchable";
type LoadState = "idle" | "loading";
export function LoadMoreRepliesButton() {
  const $ = _c(13);
  const {
    comment,
    depth
  } = useComment();
  const {
    appendReplies
  } = useCommentsActions();
  const [loadState, setLoadState] = useState("idle");
  const shouldFlatten = depth >= commentConfig.collapseRepliesFromDepth;
  let t0;
  if ($[0] !== appendReplies || $[1] !== comment.id || $[2] !== comment.replies.endCursor || $[3] !== loadState || $[4] !== shouldFlatten) {
    t0 = async () => {
      if (!comment.replies.endCursor || loadState === "loading") {
        return;
      }
      setLoadState("loading");
      const result = await fetchMoreReplies({
        commentId: comment.id,
        cursor: comment.replies.endCursor,
        flatten: shouldFlatten,
        limit: 2
      });
      if (hasSucceeded(result)) {
        appendReplies(comment.id, result.value);
      }
      if (hasFailed(result)) {
        captureClientException(new Error("Failed to load more replies"), {
          extra: {
            commentId: comment.id,
            cursor: comment.replies.endCursor
          }
        });
      }
      setLoadState("idle");
    };
    $[0] = appendReplies;
    $[1] = comment.id;
    $[2] = comment.replies.endCursor;
    $[3] = loadState;
    $[4] = shouldFlatten;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const handleLoadMore = t0;
  const t1 = loadState === "loading";
  const t2 = loadState === "loading";
  let t3;
  if ($[6] !== loadState) {
    t3 = loadState === "loading" ? <Translation da={"Indl\xE6ser..."} de="Laden..." en="Loading..." no="Laster..." sv="Laddar..." /> : <Translation da={"Indl\xE6s flere svar"} de="Mehr Antworten laden" en="Load more replies" no="Last flere svar" sv="Ladda fler svar" />;
    $[6] = loadState;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== handleLoadMore || $[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
    t4 = <div className="flex flex-col gap-1"><button aria-busy={t1} className="font-medium text-primary text-xs hover:underline focus-visible:underline focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50" disabled={t2} onClick={handleLoadMore} type="button">{t3}</button></div>;
    $[8] = handleLoadMore;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}